import Swiper from 'swiper';

export default function HeroCarousel(el) {
    const swiperContainer = el.querySelector('.swiper-container');
    const navButtons = el.querySelectorAll('.hero-carousel__navigation button');
    const contentItems = el.querySelectorAll('.hero-carousel__content-item');
    const autoplayButton = el.querySelector('.hero-carousel__toggle-autoplay');
    const delay = el.getAttribute('data-carousel-delay') || 7000;
    let contentTimer = null;

    function setAutoplayState(isPlaying) {
        const label = isPlaying ? autoplayButton.dataset.labelPause : autoplayButton.dataset.labelPlay;

        autoplayButton.classList.toggle('is-playing', isPlaying);
        autoplayButton.setAttribute('aria-label', label || (isPlaying ? 'Pause carousel' : 'Play carousel'));
    }

    setAutoplayState(true);

    const swiper = new Swiper(swiperContainer, {
        loop: true,
        slidesPerView: 1,
        autoplay: {
            delay: delay,
            disableOnInteraction: true
        },

        on: {
            slideChange: function () {
                const index = swiper.realIndex;
                updateContent(index);
                updateNavigation(index);

                // Handle play/pause state if autoplay is not running after slideChange and drag event.
                if (!swiper.autoplay.running) {
                    setAutoplayState(false);
                }
            }
        }
    });

    function updateContent(nextIndex) {
        if (contentTimer) clearTimeout(contentTimer);

        const currentIndex = [...contentItems].findIndex((item) => item.classList.contains('active'));
        const currentItem = contentItems[currentIndex];
        const nextItem = contentItems[nextIndex];

        if (!nextItem) return;

        contentItems.forEach((item, i) => {
            item.classList.remove('fade-out');

            if (i === nextIndex) {
                item.removeAttribute('inert');
            } else {
                item.setAttribute('inert', '');
            }
        });

        if (currentItem && currentIndex !== nextIndex) {
            currentItem.classList.remove('active');

            requestAnimationFrame(() => {
                currentItem.classList.add('fade-out');
            });

            contentTimer = setTimeout(() => {
                currentItem.classList.remove('fade-out');
                nextItem.classList.add('active');
            }, 500);
        } else {
            contentItems.forEach((el, i) => {
                el.classList.toggle('active', i === nextIndex);
            });
        }
    }

    function updateNavigation(index) {
        const scrollEl = el.querySelector('.hero-carousel__navigation ul');

        navButtons.forEach((btn, i) => {
            const isActive = i === index;
            btn.classList.toggle('active', isActive);

            if (isActive && scrollEl.scrollWidth > scrollEl.clientWidth) {
                const item = btn.parentElement;
                let scrollLeft;

                if (i === navButtons.length - 1) {
                    scrollLeft = scrollEl.scrollWidth - scrollEl.clientWidth;
                } else {
                    scrollLeft = item.offsetLeft;
                }

                scrollEl.scrollTo({
                    left: scrollLeft,
                    behavior: 'smooth'
                });
            }
        });
    }

    navButtons.forEach((button) => {
        button.addEventListener('mousedown', (e) => e.stopPropagation());
        button.addEventListener('touchstart', (e) => e.stopPropagation());
        button.addEventListener('click', () => {
            const index = parseInt(button.dataset.index, 10);
            swiper.slideToLoop(index);
            swiper.autoplay.stop();
            setAutoplayState(false);
            updateNavigation(index);
        });
    });

    autoplayButton.addEventListener('click', () => {
        if (swiper.autoplay.running) {
            swiper.autoplay.stop();
            setAutoplayState(false);
        } else {
            swiper.autoplay.start();
            setAutoplayState(true);
        }
    });

    /* Observer Purpose
        - Pause auto play when scrolled beyond Image carousel
    */
    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (!entry.isIntersecting) {
                    swiper.autoplay.stop();
                    setAutoplayState(false);
                }
            });
        },
        {
            threshold: 0
        }
    );

    observer.observe(swiperContainer);

    // Init
    updateContent(swiper.realIndex);
    updateNavigation(swiper.realIndex);
}
